import React from 'react';
import { Input } from '../../ui/Input';
import type { FieldType } from '../../../types/forms';

/** Field types que não mostram placeholder (render semântico não permite). */
export const NO_PLACEHOLDER_TYPES: FieldType[] = [
  'heading',
  'paragraph',
  'checkbox',
  'radio',
  'welcome_screen',
  'thank_you_screen',
  'statement',
  'yes_no',
  'nps',
  'rating',
  'opinion_scale',
  'picture_choice',
  'redirect_url',
];

export interface FieldPlaceholderInputProps {
  fieldType: FieldType;
  value: string;
  onChange: (placeholder: string) => void;
}

/**
 * Controlled editor do placeholder. Retorna null silenciosamente para tipos
 * sem placeholder semântico (mantém API simples no caller).
 */
export const FieldPlaceholderInput: React.FC<FieldPlaceholderInputProps> = ({
  fieldType,
  value,
  onChange,
}) => {
  if (NO_PLACEHOLDER_TYPES.includes(fieldType)) return null;
  return (
    <Input
      label="Placeholder"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
